import { render, staticRenderFns } from "./InsTable.vue?vue&type=template&id=72e41d76&scoped=true"
import script from "./InsTable.vue?vue&type=script&lang=js"
export * from "./InsTable.vue?vue&type=script&lang=js"
import style0 from "./InsTable.vue?vue&type=style&index=0&id=72e41d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e41d76",
  null
  
)

export default component.exports